<template>
  <v-container fluid>
    <v-card flat class="rounded-lg pa-2" height="100%">
      <div class="rounded-lg pageTitle" style="width: 100%;">
        <v-toolbar-title style="font-weight:bold;">統計資料控制</v-toolbar-title>
      </div>
    </v-card>

    <v-card
      class="rounded-lg"
    >
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        :items="statisticList"
        :headers="headers"
        :loading="isLoading"
        hide-default-header
        hide-default-footer
      >
        <template v-slot:header>
          <tr>
            <th class="greyTh pa-3">名稱</th>
            <th class="greyTh pa-3">間隔</th>
            <th class="greyTh pa-3">上次更新</th>
            <th class="greyTh pa-3">下次更新</th>
            <th class="greyTh pa-3">執行時間</th>
            <th class="greyTh pa-3"></th>
          </tr>
        </template>
        <template v-slot:item.during="{ item }">
          <span
            v-if="item.error"
            class="error"
          >
            ERROR
          </span>
          <span
            v-else
            class="heat"
            :style="`--val: ${item.during < 600 ? item.during / 5 : 120}`"
          >
            {{item.during}} ms
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <UpdateStatisticDialog @update="updateStatistic" :statistic="item" />
          <DeleteStatisticDialog @delete="deleteStatistic" :statistic="item" />
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Service from '../service/service'
import UpdateStatisticDialog from '../components/Statistic/UpdateStatisticDialog.vue'
import DeleteStatisticDialog from '../components/Statistic/DeleteStatisticDialog.vue'

export default {
  components: { UpdateStatisticDialog, DeleteStatisticDialog },
  data() {
    return {
      isLoading: false,
      statisticList: [],
      lastFetch: null,
      interval: null,
      headers: [
        {text: '名稱', value: 'name'},
        {text: '間隔', value: 'interval'},
        {text: '上次更新', value: 'last_update'},
        {text: '下次更新', value: 'exp_time'},
        {text: '執行時間', value: 'during'},
        {text: '', value: 'actions'}
      ],
    }
  },
  mounted() {
    this.getPageData()

    this.interval = setInterval(() => {
      if (!this.lastFetch) return;
      if (this.isLoading) return;

      const between = new Date() - this.lastFetch

      if (between > 30 * 1000) {
        return this.getPageData()
      }

      if (new Date().getSeconds() < 10 && between > 3 * 1000) {
        return this.getPageData()
      }
    }, 500)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    getPageData() {
      this.isLoading = true
      Service.getPageData({
        url: 'statistic_info/getPageData'
      }, true)
        .then((response) => {
          if (response.status !== 200 || response.data.status !== 0) {
            return this.showAlert('error', response.data.message)
          } 

          this.total = response.data.total
          this.statisticList = response.data.rows
        })
        .finally(() => {
          this.isLoading = false
          this.lastFetch = new Date()
        })

    },
    updateStatistic(data) {
      Service.updateData(data, 'statistic_info/update')
        .then((response) => {
          if (response.status !== 200 || !response.data.status) {
            return this.showAlert('error', response.data.message)
          } 

          this.showAlert('success', response.data.message)
          this.getPageData()
        })
    },
    deleteStatistic(data) {
      Service.deleteData([data.statistic_id], 'statistic_info/del')
        .then((response) => {
          if (response.status !== 200 || !response.data.status) {
            return this.showAlert('error', response.data.message)
          }

          this.showAlert('success', response.data.message)
          this.getPageData()
        })
    },
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
  }
}
</script>

<style scoped>
.heat {
  color: hsl(calc(120 - (var(--val) * 1.2)), 75%, 40%);
  font-weight: 600;
  transition: color 200ms ease;
}
.error {
  backgroud-color: red;
  color: white;
  font-weight: 600;
}
</style>

